import { create, useStore } from 'zustand';

import {
  AsideDialog,
  AsideDialogContent,
  AsideDialogDescription,
  AsideDialogHeader,
  AsideDialogTitle,
} from '@/components/aside-dialog';
import { AuditTrail } from '@/components/audit-trail/audit-trail';

const store = create<{
  config: AuditTrailConfig | null;
  isOpen: boolean;

  showAuditTrail: (config: AuditTrailConfig) => void;
  closeAuditTrail: () => void;
}>((set) => ({
  config: null,
  isOpen: false,

  showAuditTrail: (config: AuditTrailConfig) => {
    set({ config, isOpen: true });
  },
  closeAuditTrail: () => set({ isOpen: false }),
}));

export const useAuditTrailDialog = () => useStore(store);

export const AuditTrailDialog = () => {
  const { isOpen, closeAuditTrail } = useAuditTrailDialog();

  return (
    <AsideDialog open={isOpen} onOpenChange={closeAuditTrail}>
      <AuditTrailDialogContent />
    </AsideDialog>
  );
};

const AuditTrailDialogContent = () => {
  const { config } = useAuditTrailDialog();

  return (
    <AsideDialogContent className="lg:max-w-5xl">
      <AsideDialogHeader>
        <AsideDialogTitle>Audit trail</AsideDialogTitle>
        <AsideDialogDescription>
          View and filter the audit trail for{' '}
          <span className="font-bold">{config?.resourceLabel}</span>.
        </AsideDialogDescription>
      </AsideDialogHeader>

      <AuditTrail resourceId={config?.resourceId} />
    </AsideDialogContent>
  );
};

type AuditTrailConfig = {
  resourceId: string;
  resourceLabel: string;
};
